(ns ui.editors.card.entity-list.model
  (:require [ui.editors.card.model :as common-model]))

(def table-columns-path (into common-model/card-config-full-path [:table :columns]))

(def table-group-by-field-path (into common-model/card-config-full-path [:table :group-by-field]))

  ;; TODO: change this if multiple sort fields allowed
(def table-sort-by-field-path (into common-model/card-config-full-path [:table :sort-model 0 :field]))
(def table-sort-direction-path (into common-model/card-config-full-path [:table :sort-model 0 :direction]))

(def entity-peek-visible-fields-strategy-path (into common-model/card-config-full-path [:entity-peek :visible-fields-strategy]))

(def entity-peek-visible-fields-path (into common-model/card-config-full-path [:entity-peek :visible-fields]))
